<template>
  <div
    class="home-product-card-item"
    v-if="product"
  >
    <div
      class="home-product-card-item-icon"
      :style="`margin-bottom: ${product.mb}px;`"
    >
      <template v-if="product.is_icon">
        <i :class="`${product.icon}`" />
      </template>
      <template>
        <img
          :src="product.icon"
          alt=""
          :width="product.icon_width"
        >
      </template>
    </div>
    <div class="home-product-card-item-content">
      <h3>{{ $t(product.title) }}</h3>
      <p>{{ $t(product.description) }}</p>
      <hr style="margin-bottom: 20px !important; margin-top: 15px !important;">
      <table class="table table-borderless">
        <tbody>
          <template v-if="product.start_from">
            <tr>
              <td class="chp-title">
                {{ $t('label.from') }}
              </td>
              <td class="chp-desc">
                ${{ product.start_from }}
              </td>
            </tr>
          </template>
          <template v-if="product.up_to">
            <tr>
              <td class="chp-title">
                {{ $t('label.upto') }}
              </td>
              <td class="chp-desc">
                ${{ product.up_to }}
              </td>
            </tr>
          </template>
          <template v-if="product.over">
            <tr>
              <td class="chp-title">
                {{ $t('label.over') }}
              </td>
              <td class="chp-desc">
                {{ $t(product.over) }}
              </td>
            </tr>
          </template>
          <template v-if="product.use_for">
            <tr>
              <td class="chp-title">
                {{ $t('label.for') }}
              </td>
              <td class="chp-desc">
                {{ $t(product.use_for) }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="btn-link-bottom">
      <router-link
        to="/"
        class="btn btn-cash-hero"
        :title="$t(product.title)"
        @click.native="toRoute(product.link)"
      >
        {{ $t('button.applyNow') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HomeProductCardItem',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: Object.assign(mapState({
    data: state => state.borrow
  })),
  methods: {
    toRoute (route_name) {
      if (route_name === 'payday_loan') {
        this.data.loanType = 'Payday'
        this.$router.push({ name: 'borrow-form', params: { formType: 'borrow' } })
      } else if (route_name === 'personal_loan') {
        this.data.loanType = 'Personal'
        this.$router.push({ name: 'borrow-form', params: { formType: 'borrow' } })
      } else if (route_name === 'purchasing') {
        this.data.loanType = 'Purchasing'
        this.$router.push({ name: 'purchasing-form', params: { formType: 'borrow' } })
      } else if (route_name === 'pawn') {
        this.data.loanType = 'Pawn'
        this.$router.push({ name: 'pawn-form', params: { formType: 'borrow' } })
      }
    }
  }
}
</script>

<style scoped>
.home-product-card-item {
  position: relative;
  height: 525px;
  padding: 20px;
  border-radius: var(--border-raduis);
  margin-bottom: 15px;
  background-image: linear-gradient(179deg, #008bf806 29%, var(--shade) 102%);
  box-shadow: 0 0 1px 0 rgba(28, 28, 28, 0.05), 0 5px 13px 0 rgba(28, 28, 28, 0.1);
}

.home-product-card-item-icon {
  color: #a0a0a0;
  font-size: 34px;
  font-weight: normal;
}

.home-product-card-item-content h3 {
  margin-bottom: 18px;
}

.home-product-card-item-content p {
  font-size: 14px;
  min-height: 85px;
  margin-bottom: 0;
}

.table th, .table td {
  padding: 0.25rem 0 !important;
}

.chp-title {
  width: 20%;
  font-size: 14px;
  font-weight: 500;
}
.chp-desc {
  width: 80%;
  text-align: right;
  font-size: 14px;
  margin-bottom: 0;
}

.btn-link-bottom {
  position: absolute;
  bottom: 20px;
}

@media screen and (max-width: 991.89px){
  .home-product-card-item {
    height: 490px;
  }
}

@media screen and (max-width: 576px){
  .home-product-card-item {
    height: 480px;
  }
}
</style>
